import { render, staticRenderFns } from "./PropertyFeeForm.vue?vue&type=template&id=49c3a61f"
import script from "./PropertyFeeForm.vue?vue&type=script&lang=js"
export * from "./PropertyFeeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports